import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

export interface Class {
  id: string;
  name: string;
}

export interface Source {
  id: string;
  name: string;
}

export interface Offer {
  id: string;
  name: string;
  summary: string;
  offerUrl: string;
  class: Class;
  source: Source;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  offersCollection: AngularFirestoreCollection<Offer>;
  offers: Observable<Offer[]>;
  searchterm: String = '';

  constructor(private router: Router, private afs: AngularFirestore) {
  }

  ngOnInit() {
    this.offersCollection = this.afs.collection('offers', ref => {
      return ref.orderBy('name').limit(15);
    });
    this.offers = this.offersCollection.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Offer;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }

  search() {
    const self = this;
    this.offersCollection = self.afs.collection(`offers`, ref => ref
      .orderBy('nameLowerCase')
      .startAt(this.searchterm.toLowerCase())
      .endAt(this.searchterm.toLowerCase() + '\uf8ff')
      .limit(15));
    this.offers = this.offersCollection.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Offer;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }
 /*
  filter(offer: Offer): boolean {
    // Return true if don't want this offer in the results.
    // We filter on searhcterm;
    const regex = new RegExp('' + this.searchterm.toLowerCase() + '', 'g');
    const res = offer.brandName.toLowerCase().match(regex);
    if (!res) {
      return true;
    }
    return false;
  }
  */
  /*
  offerClicked(offer: Offer) {
    open(offer.offerURL, '_blank');
    // Log a click
  }*/

  openOffer(offer: Offer) {
    this.router.navigate(['/offer/' + offer.id]);
    // Log a click
  }

}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts